// Common
import commonIconShowPassword from '~/assets/icons/common_icon_show_password.svg';
import commonIconHidePassword from '~/assets/icons/common_icon_hide_password.svg';
import commonIconArrowLeft from '~/assets/icons/common_icon_arrow_left.svg';
import commonIconArrowRight from '~/assets/icons/common_icon_arrow_right.svg';
import commonIconLogoFull from '~/assets/icons/common_icon_logo_full.svg';
import commonIconLogo from '~/assets/icons/common_icon_logo.svg';
import commonIconArrowDown from '~/assets/icons/common_icon_arrow_down.svg';
import commonIconFileUpload from '~/assets/icons/common_icon_file_upload.svg';
import commonIconClose from '~/assets/icons/common_icon_close.svg';
import commonIconBack from '~/assets/icons/common_icon_back.svg';
import commonIconEyeShow from '~/assets/icons/common_icon_eye_show.svg';
import commonIconEyeHidden from '~/assets/icons/common_icon_eye_hidden.svg';
import commonIconCloseField from '~/assets/icons/common_icon_close_field.svg';
import commonIconAddField from '~/assets/icons/common_icon_add_field_primary.svg';
import commonIconFileDefault from '~/assets/icons/common_icon_file_default.svg';
import commonIconUncheck from '~/assets/icons/common_icon_uncheck.svg';
import commonIconChecked from '~/assets/icons/common_icon_checked.svg';
import commonIconIndeterminate from '~/assets/icons/common_icon_indeterminate.svg';
import commonIconMoreActive from '~/assets/icons/common_icon_more_active.svg';
import commonIconMoreInactive from '~/assets/icons/common_icon_more_inactive.svg';
import commonIconInputSearch from '~/assets/icons/common_icon_input_search.svg';
import commonIconClock from '~/assets/icons/common_icon_clock.svg';
import commonIconCalendar from '~/assets/icons/common_icon_calendar.svg';
import commonIconConvert from '~/assets/icons/common_icon_convert.svg';
import commonIconMoreAvatar from '~/assets/icons/common_icon_more_avatar.svg';
import commonIconSplitButton from '~/assets/icons/common_icon_split_button.svg';
import commonIconCheckMark from '~/assets/icons/common_icon_check_mark.svg';
import commonIconVideo from '~/assets/icons/common_icon_video.svg';
import commonIconSendMessage from '~/assets/icons/common_icon_send_message.svg';
import commonIconPlus from '~/assets/icons/common_icon_plus.svg';
import commonIconDocument from '~/assets/icons/common_icon_document.svg';
import commonIconJob from '~/assets/icons/common_icon_job.svg';
import commonIconEstimate from '~/assets/icons/common_icon_estimate.svg';
import commonIconEditPrimary from '~/assets/icons/common_icon_edit_primary.svg';
import commonIconUndo from '~/assets/icons/common_icon_undo.svg';
import commonIconNoData from '~/assets/icons/common_icon_no_data.svg';
import commonIconFileDocs from '~/assets/icons/common_icon_file_docs.svg';
import commonIconFileXls from '~/assets/icons/common_icon_file_xls.svg';
import commonIconFilePdf from '~/assets/icons/common_icon_file_pdf.svg';
import commonIconWarning from '~/assets/icons/common_icon_warning.svg';

// Menu
import menuIconDashboardActive from '~/assets/icons/menu_icon_dashboard_active.svg';
import menuIconDashboardInactive from '~/assets/icons/menu_icon_dashboard_inactive.svg';
import menuIconEmployeesActive from '~/assets/icons/menu_icon_employees_active.svg';
import menuIconEmployeesInactive from '~/assets/icons/menu_icon_employees_inactive.svg';
import menuIconCustomersActive from '~/assets/icons/menu_icon_customers_active.svg';
import menuIconCustomersInactive from '~/assets/icons/menu_icon_customers_inactive.svg';
import menuIconScheduleActive from '~/assets/icons/menu_icon_schedule_active.svg';
import menuIconScheduleInactive from '~/assets/icons/menu_icon_schedule_inactive.svg';
import menuIconCRMActive from '~/assets/icons/menu_icon_crm_active.svg';
import menuIconCRMInactive from '~/assets/icons/menu_icon_crm_inactive.svg';
import menuIconTasksActive from '~/assets/icons/menu_icon_tasks_active.svg';
import menuIconTasksInactive from '~/assets/icons/menu_icon_tasks_inactive.svg';
import menuIconTimeClockActive from '~/assets/icons/menu_icon_time_clock_active.svg';
import menuIconTimeClockInactive from '~/assets/icons/menu_icon_time_clock_inactive.svg';
import menuIconPayrollActive from '~/assets/icons/menu_icon_payroll_active.svg';
import menuIconPayrollInactive from '~/assets/icons/menu_icon_payroll_inactive.svg';
import menuIconReportsActive from '~/assets/icons/menu_icon_reports_active.svg';
import menuIconReportsInactive from '~/assets/icons/menu_icon_reports_inactive.svg';
import menuIconSettingsActive from '~/assets/icons/menu_icon_settings_active.svg';
import menuIconSettingsInactive from '~/assets/icons/menu_icon_settings_inactive.svg';
import menuIconJobsActive from '~/assets/icons/menu_icon_jobs_active.svg';
import menuIconJobsInactive from '~/assets/icons/menu_icon_jobs_inactive.svg';
import menuIconCategoryActive from '~/assets/icons/menu_icon_category_active.svg';
import menuIconCategoryInactive from '~/assets/icons/menu_icon_category_inactive.svg';
import menuIconPriceBookActive from '~/assets/icons/menu_icon_price_book_active.svg';
import menuIconPriceBookInactive from '~/assets/icons/menu_icon_price_book_inactive.svg';
import menuIconMarketingActive from '~/assets/icons/menu_icon_marketing_active.svg';
import menuIconMarketingInactive from '~/assets/icons/menu_icon_marketing_inactive.svg';
import menuIconEstimateActive from '~/assets/icons/menu_icon_estimate_active.svg';
import menuIconEstimateInactive from '~/assets/icons/menu_icon_estimate_inactive.svg';
import menuIconInvoiceActive from '~/assets/icons/menu_icon_invoice_active.svg';
import menuIconInvoiceInactive from '~/assets/icons/menu_icon_invoice_inactive.svg';
import MenuIconReviewInactive from '~/assets/icons/menu_icon_review_inactive.svg';
import MenuIconReviewActive from '~/assets/icons/menu_icon_review_active.svg';

// Header
import headerIconNotification from '~/assets/icons/header_icon_notification.svg';
import headerIconMessage from '~/assets/icons/header_icon_message.svg';
import headerIconEmail from '~/assets/icons/header_icon_email.svg';

// Table
import tableIconMenuDots from '~/assets/icons/table_icon_menu_dots.svg';
import tableIconUncheck from '~/assets/icons/table_icon_uncheck.svg';
import tableIconChecked from '~/assets/icons/table_icon_checked.svg';
import tableIconIndeterminate from '~/assets/icons/table_icon_indeterminate.svg';
import tableIconActionView from '~/assets/icons/table_icon_action_view.svg';
import tableIconActionEdit from '~/assets/icons/table_icon_action_edit.svg';
import tableIconActionCall from '~/assets/icons/table_icon_action_call.svg';
import tableIconActionSMS from '~/assets/icons/table_icon_action_sms.svg';
import tableIconActionMail from '~/assets/icons/table_icon_action_mail.svg';
import tableIconActionConvert from '~/assets/icons/table_icon_action_convert.svg';
import tableIconActionDelete from '~/assets/icons/table_icon_action_delete.svg';
import tableIconActionMakeStatus from '~/assets/icons/table_icon_status_indicator.svg';
import tableIconActionMakeAsPaid from '~/assets/icons/table_icon_action_paid.svg';
import tableIconActionMakeAsUnpaid from '~/assets/icons/table_icon_action_unpaid.svg';
import tableIconActionMessage from '~/assets/icons/table_icon_action_message.svg';
import tableIconActionChangeStatus from '~/assets/icons/table_icon_action_change_status.svg';
import tableIconActionSendEstimate from '~/assets/icons/table_icon_action_send_estimate.svg';
import tableIconActionSendToQuickBooks from '~/assets/icons/table_icon_action_send_to_quick_books.svg';

// Pagination
import paginationIconPreviousDisabled from '~/assets/icons/pagination_icon_previous_disabled.svg';
import paginationIconPreviousActive from '~/assets/icons/pagination_icon_previous_active.svg';
import paginationIconNextDisabled from '~/assets/icons/pagination_icon_next_disabled.svg';
import paginationIconNextActive from '~/assets/icons/pagination_icon_next_active.svg';

// Filter
import filterIconDefault from '~/assets/icons/filter_icon_default.svg';

// Document
import documentIconFolderActive from '~/assets/icons/document_icon_folder_active.svg';
import documentIconFolderInactive from '~/assets/icons/document_icon_folder_inactive.svg';
import documentIconDocument from '~/assets/icons/document_icon_document.svg';

// Activity
import activityIconCreate from '~/assets/icons/activity_icon_create.svg';
import activityIconUpdate from '~/assets/icons/activity_icon_update.svg';
import activityIconDelete from '~/assets/icons/activity_icon_delete.svg';

// Schedule
import scheduleIconNext from '~/assets/icons/schedule_icon_next.svg';
import scheduleIconPrevious from '~/assets/icons/schedule_icon_previous.svg';
import scheduleIconCalendarActive from '~/assets/icons/schedule_icon_calendar_active.svg';
import scheduleIconCalendarInactive from '~/assets/icons/schedule_icon_calendar_inactive.svg';

// Pipeline
import pipelineIconPhone from '~/assets/icons/pipeline_icon_phone.svg';
import pipelineIconEmail from '~/assets/icons/pipeline_icon_email.svg';

// Drawer
import drawerIconArrowClose from '~/assets/icons/drawer_icon_arrow_close.svg';

// Employee
import employeeIconEditInfo from '~/assets/icons/employee_icon_edit_info.svg';
import employeeIconMessage from '~/assets/icons/employee_icon_message.svg';

// Profile
import profileIconProfile from '~/assets/icons/profile_icon_profile.svg';
import profileIconSetting from '~/assets/icons/profile_icon_setting.svg';
import profileIconLogout from '~/assets/icons/profile_icon_logout.svg';

// Conversation
import conversationIconFileDefault from '~/assets/icons/conversation_icon_file_default.svg';
import conversationIconStatusSent from '~/assets/icons/conversation_icon_status_sent.svg';
import conversationIconStatusDelivered from '~/assets/icons/conversation_icon_status_delivered.svg';
import conversationIconStatusSeen from '~/assets/icons/conversation_icon_status_seen.svg';
import conversationIconSearch from '~/assets/icons/conversation_icon_search.svg';
import conversationIconUploadFile from '~/assets/icons/conversation_icon_upload_file.svg';

// Create Job Tab
import tabIconPlus from '~/assets/icons/tab_icon_plus.svg';
import createJobTabIconCustomer from '~/assets/icons/create_job_tab_icon_customer.svg';
import createJobTabIconSchedule from '~/assets/icons/create_job_tab_icon_schedule.svg';
import createJobTabIconPrivateNotes from '~/assets/icons/create_job_tab_icon_private_notes.svg';
import createJobTabIconJobFields from '~/assets/icons/create_job_tab_icon_job_fields.svg';
import createJobTabIconTags from '~/assets/icons/create_job_tab_icon_tags.svg';
import createJobTabIconLeadSource from '~/assets/icons/create_job_tab_icon_lead_source.svg';
import createJobTabIconTask from '~/assets/icons/create_job_tab_icon_task.svg';
import createJobTabIconAttachment from '~/assets/icons/create_job_tab_icon_photo.svg';

// Invoice
import invoiceIconCreateInvoice from '~/assets/icons/invoice_icon_create_invoice.svg';

// Integration
import integrationIconGoogleLogo from './integration_icon_google_logo.svg';
import integrationIconQuickBooksLogo from './integration_icon_quickbooks_logo.svg';

const icons = {
  // Common
  commonIconArrowLeft,
  commonIconArrowRight,
  commonIconLogoFull,
  commonIconLogo,
  commonIconShowPassword,
  commonIconHidePassword,
  commonIconEyeHidden,
  commonIconFileUpload,
  commonIconClose,
  commonIconBack,
  commonIconArrowDown,
  commonIconEyeShow,
  commonIconCloseField,
  commonIconAddField,
  commonIconFileDefault,
  commonIconUncheck,
  commonIconChecked,
  commonIconIndeterminate,
  commonIconMoreActive,
  commonIconMoreInactive,
  commonIconInputSearch,
  commonIconClock,
  commonIconCalendar,
  commonIconConvert,
  commonIconMoreAvatar,
  commonIconSplitButton,
  commonIconCheckMark,
  commonIconVideo,
  commonIconSendMessage,
  commonIconPlus,
  commonIconDocument,
  commonIconJob,
  commonIconEstimate,
  commonIconEditPrimary,
  commonIconUndo,
  commonIconNoData,
  commonIconFileDocs,
  commonIconFilePdf,
  commonIconFileXls,
  commonIconWarning,

  // Menu
  menuIconDashboardActive,
  menuIconDashboardInactive,
  menuIconEmployeesActive,
  menuIconEmployeesInactive,
  menuIconCustomersActive,
  menuIconCustomersInactive,
  menuIconScheduleActive,
  menuIconScheduleInactive,
  menuIconCRMActive,
  menuIconCRMInactive,
  menuIconTasksActive,
  menuIconTasksInactive,
  menuIconTimeClockActive,
  menuIconTimeClockInactive,
  menuIconPayrollActive,
  menuIconPayrollInactive,
  menuIconReportsActive,
  menuIconReportsInactive,
  menuIconSettingsActive,
  menuIconSettingsInactive,
  menuIconJobsActive,
  menuIconJobsInactive,
  menuIconCategoryActive,
  menuIconCategoryInactive,
  menuIconPriceBookActive,
  menuIconPriceBookInactive,
  menuIconMarketingActive,
  menuIconMarketingInactive,
  menuIconEstimateActive,
  menuIconEstimateInactive,
  menuIconInvoiceInactive,
  menuIconInvoiceActive,
  MenuIconReviewInactive,
  MenuIconReviewActive,

  // Header
  headerIconNotification,
  headerIconMessage,
  headerIconEmail,

  // Table
  tableIconMenuDots,
  tableIconUncheck,
  tableIconChecked,
  tableIconIndeterminate,
  tableIconActionView,
  tableIconActionEdit,
  tableIconActionCall,
  tableIconActionSMS,
  tableIconActionMail,
  tableIconActionConvert,
  tableIconActionDelete,
  tableIconActionMakeStatus,
  tableIconActionMakeAsPaid,
  tableIconActionMakeAsUnpaid,
  tableIconActionMessage,
  tableIconActionChangeStatus,
  tableIconActionSendEstimate,
  tableIconActionSendToQuickBooks,

  // Pagination
  paginationIconPreviousDisabled,
  paginationIconPreviousActive,
  paginationIconNextDisabled,
  paginationIconNextActive,

  // Schedule
  scheduleIconNext,
  scheduleIconPrevious,
  scheduleIconCalendarActive,
  scheduleIconCalendarInactive,

  // Filter
  filterIconDefault,

  // Document
  documentIconFolderActive,
  documentIconFolderInactive,
  documentIconDocument,

  // Activity
  activityIconCreate,
  activityIconUpdate,
  activityIconDelete,

  // Pipeline
  pipelineIconPhone,
  pipelineIconEmail,

  // Drawer
  drawerIconArrowClose,

  // Employee
  employeeIconEditInfo,
  employeeIconMessage,

  // Profile
  profileIconProfile,
  profileIconSetting,
  profileIconLogout,

  // Conversation
  conversationIconFileDefault,
  conversationIconStatusSent,
  conversationIconStatusDelivered,
  conversationIconStatusSeen,
  conversationIconSearch,
  conversationIconUploadFile,

  // Create Job Tab
  tabIconPlus,
  createJobTabIconCustomer,
  createJobTabIconSchedule,
  createJobTabIconPrivateNotes,
  createJobTabIconJobFields,
  createJobTabIconTags,
  createJobTabIconLeadSource,
  createJobTabIconTask,
  createJobTabIconAttachment,

  // Invoice
  invoiceIconCreateInvoice,

  // Integration
  integrationIconGoogleLogo,
  integrationIconQuickBooksLogo,
};

export default icons;
